import React, { Component, Fragment } from "react";
import SVGInline from "react-svg-inline";
import ProgressiveImage from "react-progressive-image";

import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";

/* eslint import/no-webpack-loader-syntax: off */
import logoObersoundWhiteSVG from "!raw-loader!../images/logos/logo-obersound-white.svg";
import iconScrollSVG from "!raw-loader!../images/icons/scroll-icon.svg";
import homeImage from "../images/home.jpg";
import homeCompositionImage from "../images/home-composition.jpg";
import homeSurfaceImage from "../images/home-composition2.jpg";

import BottomActionsImage from "../images/actions.jpg";
import BottomCollectionsImage from "../images/collections.jpg";
import BottomClassicsImage from "../images/classics.jpg";

// PATTERNS
import patternErase from "../images/patterns/pattern-erase.svg";
import patternStretch from "../images/patterns/pattern-stretch.svg";
import patternCompose from "../images/patterns/pattern-compose.svg";
import patternGrease from "../images/patterns/pattern-grease.svg";
import patternShake from "../images/patterns/pattern-shake.svg";
import patternBlow from "../images/patterns/pattern-blow.svg";
import { patternsByIds } from "../constants/patterns";


class Home extends Component {
  constructor(props) {
    super(props);

    this.handleScrollButtonClick = this.handleScrollButtonClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.state = { windowInnerHeight: window.innerHeight };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.setState({
      windowInnerHeight: window.innerHeight
    });
  }

  handleScrollButtonClick() {
    if (this.ctaRef.scrollIntoView) {
      this.ctaRef.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, this.state.windowInnerHeight);
    }
  }

  render() {
    const heightStyle = { height: this.state.windowInnerHeight };

    return (
      <Fragment>
        {/* video page */}
        <div className="w-100 vh-100 overflow-hidden" style={heightStyle}>
          <ProgressiveImage src={homeImage} placeholder={homeImage}>
            {(src, loading) => (
              <div
                className="w-100 h-100 cover"
                style={{ backgroundImage: `url(${src})` }}
              />
            )}
          </ProgressiveImage>

          <div className="absolute top-0 left-0 z-1 w-100 flex items-center vh-100">
            <div className="relative center tc">
              <SVGInline width={"720px"} svg={logoObersoundWhiteSVG} />
            </div>
            <div
              className="absolute left-0 bottom-0 w-100 pv6 tc pointer"
              onClick={this.handleScrollButtonClick}
            >
              <SVGInline
                width="64px"
                svg={iconScrollSVG}
                className="hover-scale"
              />
            </div>
          </div>
        </div>

        {/* cta page */}
        <div
          className="w-100 vh-100 overflow-hidden"
          style={heightStyle}
          ref={ref => (this.ctaRef = ref)}
        >
          <div
            className="flex items-center vh-100"
            style={{ backgroundImage: `url(${homeCompositionImage})` }}
          >
            <div className="home__headline">
              <div className="home__headline-title">{this.props.t("common:labelActions55")}</div>
              <div className="home__headline-subtitle">
                {this.props.t("page2Action55Description")}
              </div>
            </div>
          </div>
        </div>

        {/* patterns */}
        <div className="home__section">
          <div className="home__section-title">
            {this.props.t("page3Description")}
          </div>
        </div>

        <div className="grid grid--6 bt bb b--black">
          <div className="grid__item">
            <div
              className="grid__item-image"
              style={{ backgroundImage: `url(${patternStretch})` }}
            />
            <div className="grid__item-label">{patternsByIds[6]["title_"+this.props.lng]}</div> {/*ETIRER*/}
          </div>
          <div className="grid__item">
            <div
              className="grid__item-image"
              style={{ backgroundImage: `url(${patternErase})` }}
            />
            <div className="grid__item-label">{patternsByIds[7]["title_"+this.props.lng]}</div> {/*GOMMER*/}
          </div>
          <div className="grid__item">
            <div
              className="grid__item-image"
              style={{ backgroundImage: `url(${patternCompose})` }}
            />
            <div className="grid__item-label">{patternsByIds[0]["title_"+this.props.lng]}</div> {/*COMPOSER*/}
          </div>
          <div className="grid__item">
            <div
              className="grid__item-image"
              style={{ backgroundImage: `url(${patternGrease})` }}
            />
            <div className="grid__item-label">{patternsByIds[8]["title_"+this.props.lng]}</div> {/*GRAISSER*/}
          </div>
          <div className="grid__item">
            <div
              className="grid__item-image"
              style={{ backgroundImage: `url(${patternShake})` }}
            />
            <div className="grid__item-label">{patternsByIds[9]["title_"+this.props.lng]}</div> {/*SECOUER*/}
          </div>
          <div className="grid__item">
            <div
              className="grid__item-image"
              style={{ backgroundImage: `url(${patternBlow})` }}
            />
            <div className="grid__item-label">{patternsByIds[10]["title_"+this.props.lng]}</div> {/*SOUFFLER*/}
          </div>
        </div>

        {/* CTA create model */}
        <div className="w-100 overflow-hidden">
          <div
            className="flex items-center pv6"
            style={{ backgroundImage: `url(${homeSurfaceImage})` }}
          >
            <div className="center tc">
              <LocalizedLink className="button button--xlarge" to="/create">
                {this.props.t("common:labelCreateYourModel")}
                <i className="button__icon i-arrow-right-light" />
              </LocalizedLink>
            </div>
          </div>
        </div>

        {/* TEXT */}
        <div className="home__section">
          <div className="home__section-title">
            {this.props.t("page4Description")}
          </div>
        </div>

        {/* 3 STEPS */}
        <div className="steps">
          <div className="steps__item">
            <div className="steps__item-number">
              <span>1</span>
            </div>
            <div className="steps__item-title">
            {this.props.t("page4Step1Title")}
            </div>
            <div className="steps__item-text">
            {this.props.t("page4Step1Description")}
            </div>
          </div>
          <div className="steps__item">
            <div className="steps__item-number">
              <span>2</span>
            </div>
            <div className="steps__item-title">
            {this.props.t("page4Step2Title")}

            </div>
            <div className="steps__item-text">
            {this.props.t("page4Step2Description")}
            </div>
          </div>
          <div className="steps__item">
            <div className="steps__item-number">
              <span>3</span>
            </div>
            <div className="steps__item-title">
            {this.props.t("page4Step3Title")}
              </div>
            <div className="steps__item-text">
            {this.props.t("page4Step3Description")}
            </div>
          </div>
        </div>

        {/* TEXT */}
        <div className="home__section">
          <div className="home__section-title">
          {this.props.t("page5Title")}
          </div>
        </div>

        {/* 3 ITEMS */}
        <div className="collection">
          <div
            className="collection__item"
            style={{ backgroundImage: `url(${BottomActionsImage})` }}
          >
            <div className="collection__item-title">{this.props.t("common:labelActions55")}</div>
            <div className="collection__item-text">
            {this.props.t("page5Pattern1Description")}
            </div>

            <LocalizedLink className="button" to="/create">
              {this.props.t("common:labelCreateYourModel")}
              <i className="button__icon i-arrow-right-light" />
            </LocalizedLink>
          </div>

          <div
            className="collection__item"
            style={{ backgroundImage: `url(${BottomCollectionsImage})` }}
          >
            <div className="collection__item-title">{this.props.t("common:labelCollections55")}</div>
            <div className="collection__item-text">
              {this.props.t("page5Pattern2Description")}
            </div>
            <LocalizedLink className="button" to="/create">
              {this.props.t("common:labelCreateYourModel")}
              <i className="button__icon i-arrow-right-light" />
            </LocalizedLink>
          </div>

          <div
            className="collection__item"
            style={{ backgroundImage: `url(${BottomClassicsImage})` }}
          >
            <div className="collection__item-title">{this.props.t("common:labelClassics")}</div>
            <div className="collection__item-text">
              {this.props.t("page5Pattern3Description")}
            </div>
            <LocalizedLink className="button" to="/create">
              {this.props.t("common:labelCreateYourModel")}
              <i className="button__icon i-arrow-right-light" />
            </LocalizedLink>
          </div>
        </div>

        <Footer t={this.props.t} />
      </Fragment>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js